import React, { useState, useEffect } from 'react';
import BaseScadaNode from './BaseScadaNode';
import { LineChart, Line, ResponsiveContainer, Tooltip, YAxis } from 'recharts';

export default function TrendChartNode(props) {
    const { data } = props;
    const config = data?.config || {};
    const maxPoints = config.max_points || 60;
    const [history, setHistory] = useState([]);

    useEffect(() => {
        const raw = data?.liveValues?.value ?? data?.liveValue;
        if (raw === undefined || raw === null) return;
        const v = parseFloat(raw);
        if (isNaN(v)) return;
        setHistory(prev => {
            const next = [...prev, { value: v, t: Date.now() }];
            return next.slice(-maxPoints);
        });
    }, [data?.liveValues?.value, data?.liveValue]);

    const w = data?.width || 120;
    const h = data?.height || 60;
    const lineColor = config.line_color || '#4F46E5';

    return (
        <BaseScadaNode {...props}>
            <div style={{ width: '100%', height: '100%', background: '#0F172A', borderRadius: 4, padding: 4, boxSizing: 'border-box' }}>
                {data?.label && (
                    <div style={{ fontSize: 9, color: '#64748B', marginBottom: 2, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                        {data.label}
                    </div>
                )}
                <ResponsiveContainer width="100%" height="85%">
                    <LineChart data={history}>
                        <YAxis domain={['auto', 'auto']} hide width={0} />
                        <Tooltip
                            contentStyle={{ background: '#1E293B', border: '1px solid #334155', fontSize: 10, borderRadius: 4, padding: '2px 6px' }}
                            itemStyle={{ color: lineColor }}
                            formatter={(v) => [v.toFixed(config.decimals ?? 1), config.unit || 'value']}
                            labelFormatter={() => ''}
                        />
                        <Line type="monotone" dataKey="value" stroke={lineColor} dot={false} strokeWidth={1.5} isAnimationActive={false} />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </BaseScadaNode>
    );
}
